export default "__VITE_ASSET__BjJdodlb__"